module.exports = __webpack_public_path__ + "img/evaluation.7b140477.png";